import { Outlet, type RouteObject } from 'react-router-dom';
import { CONTEXTS } from '@/app/registry';

export const adminSkillUpRoutes: RouteObject[] = [
  {
    path: 'admin/skill-up-nodes',
    Component: Outlet,
    handle: { context: CONTEXTS.ADMIN_SKILL_UP_NODES, title: 'Nœuds Skill-Up' },
  },
  {
    path: 'admin/skill-up-nodes/new',
    Component: Outlet,
    handle: { context: CONTEXTS.ADMIN_SKILL_UP_NODE_FORM, title: 'Nouveau nœud' },
  },
  {
    path: 'admin/skill-up-nodes/:nodeId/edit',
    Component: Outlet,
    handle: { context: CONTEXTS.ADMIN_SKILL_UP_NODE_FORM, title: 'Modifier le nœud' },
  },
  {
    path: 'admin/skill-up-nodes/:nodeId/links',
    Component: Outlet,
    handle: { context: CONTEXTS.ADMIN_SKILL_UP_NODE_LINKS, title: 'Liaisons du nœud' },
  },
  {
    path: 'admin/skill-up-concepts',
    Component: Outlet,
    handle: { context: CONTEXTS.ADMIN_SKILL_UP_CONCEPTS, title: 'Concepts Skill-Up' },
  },
  {
    path: 'admin/skill-up-concepts/new',
    Component: Outlet,
    handle: { context: CONTEXTS.ADMIN_SKILL_UP_CONCEPT_FORM, title: 'Nouveau concept' },
  },
  {
    path: 'admin/skill-up-concepts/:conceptId/edit',
    Component: Outlet,
    handle: { context: CONTEXTS.ADMIN_SKILL_UP_CONCEPT_FORM, title: 'Modifier le concept' },
  },
  {
    path: 'admin/skill-up-concepts/:conceptId/roadmap',
    Component: Outlet,
    handle: { context: CONTEXTS.ADMIN_SKILL_UP_CONCEPT_ROADMAP, title: 'Roadmap du concept' },
  },
];
